import { render, staticRenderFns } from "./audit-item-template-model.vue?vue&type=template&id=0180648c&scoped=true"
import script from "./audit-item-template-model.vue?vue&type=script&lang=js"
export * from "./audit-item-template-model.vue?vue&type=script&lang=js"
import style0 from "./audit-item-template-model.vue?vue&type=style&index=0&id=0180648c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180648c",
  null
  
)

export default component.exports